import React from "react";
import contextProvider from "../../contextProvider";
import { withRouter } from "react-router-dom";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";
import { Row, Col, Badge } from "reactstrap";
import Panel from "../../_L1_components/Layout/Panel";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";

class StepTimingGraph extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: {},
      measure_graph: {},
      step_graph: null,
      timingView: false,
      _activePopup: null,
      _popupData: {},
    };
    super(props, initState);
    this.apiStore = null;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onAppMounted() {}

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this.callsSet = this.apiStore.newCallsSet({
      state_setter: this._getStateSetter(),
      calls_set: {
        get_measure_graph_popup: {
          api_id: "get_measure_graph_popup",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
        },
        get_measure_graph_popup_aggregate: {
          api_id: "get_measure_graph_popup_aggregate",
          set_state: false,
          static_data: {
            // probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
        },
        get_measure_note: {
          api_id: "get_measure_note",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
        create_measure_note: {
          api_id: "create_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
        set_measure_note: {
          api_id: "set_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
        delete_measure_note: {
          api_id: "delete_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
      },
    });
  }

  onComponentWillUnmount() {}

  setActivePopup(tick_data) {
    tick_data.notes = this._explorerParameters._notes.filter((value) => {
      return (
        value.ts >= tick_data.ts &&
        value.ts < tick_data.ts + this._explorerParameters._divider
      );
    });
    this.setState(
      {
        _activePopup: tick_data,
      },
      () => {
        if (!tick_data._is_zoom) {
          if (
            this.state._popupData[
              this.props.match.params.probeuid +
                "_" +
                this.props.match.params.measureid +
                "_" +
                this.props.match.params.bssid +
                "_" +
                tick_data.ts
            ]
          ) {
            this.setState((prev_state) => {
              prev_state._activePopup.data =
                this.state._popupData[
                  this.props.match.params.probeuid +
                    "_" +
                    this.props.match.params.measureid +
                    "_" +
                    this.props.match.params.bssid +
                    "_" +
                    tick_data.ts
                ];
              return prev_state;
            });
          } else {
            if (this._popupLoadingTimeout) {
              clearTimeout(this._popupLoadingTimeout);
            }
            this._popupLoadingTimeout = setTimeout(() => {
              this.setState(
                {
                  loading_popup: true,
                },
                () => {
                  let urlToFetch =
                    this.props.urlToFetch || "get_measure_graph_popup";
                  this.callsSet.call(urlToFetch, {
                    data_input: {
                      ts: tick_data.ts,
                      mlist: this.props.mlist || undefined,
                      rrdPath: this.props.rrdPath || undefined,
                    },
                    on_success: (response_status, response_data) => {
                      response_data[0].data.graphPopupData.phases_colors = {};
                      response_data[0].data.graphPopupData.phases_sequence.forEach(
                        (entry, index) => {
                          response_data[0].data.graphPopupData.phases_colors[
                            entry
                          ] =
                            this.props.data.graphData.highlights &&
                            this.props.data.graphData.highlights[entry]
                              ? this.props.data.graphData.highlights[entry]
                              : this.props.phaseColors[
                                  parseInt(
                                    (index *
                                      (this.props.phaseColors.length +
                                        this.props.phaseColors.length /
                                          response_data[0].data.graphPopupData
                                            .phases_sequence.length)) /
                                      response_data[0].data.graphPopupData
                                        .phases_sequence.length
                                  )
                                ];
                        }
                      );
                      this.setState((prev_state) => {
                        prev_state._popupData[
                          this.props.match.params.probeuid +
                            "_" +
                            this.props.match.params.measureid +
                            "_" +
                            this.props.match.params.bssid +
                            "_" +
                            tick_data.ts
                        ] = response_data[0].data;
                        prev_state.loading_popup = false;
                        return prev_state;
                      });
                    },
                  });
                }
              );
            }, 500);
          }
        }
      }
    );
  }

  unsetActivePopup(tick_data) {
    this.setState(
      {
        _activePopup: null,
      },
      () => {
        if (this._popupLoadingTimeout) {
          clearTimeout(this._popupLoadingTimeout);
        }
      }
    );
  }

  onRender() {
    let _popup = (position) => {
      return this.state._activePopup ? (
        !this.state._activePopup._is_zoom ? (
          (() => {
            let popupData =
              this.state._popupData[
                this.props.match.params.probeuid +
                  "_" +
                  this.props.match.params.measureid +
                  "_" +
                  this.props.match.params.bssid +
                  "_" +
                  this.state._activePopup.ts
              ];

            return (
              <Panel
                className="graph-explorer-popup-detail margin-stepTiming border-0"
                rounded
                bodyClassName="p-0"
                header={
                  <div className="text-center text-light">
                    <div className="d-flex"></div>
                    <div className={position == "static" ? "mt-2" : ""}>
                      <span className="icon-calendar mr-2" />
                      {this.getAppContext()
                        .momentjs(this.state._activePopup.ts, "X")
                        .format("L LT")}
                      {popupData &&
                      popupData.graphPopupData.measures_count > 0 ? (
                        <div
                          className={
                            "sub-title" +
                            (popupData.graphPopupData.errors_count > 0
                              ? popupData.graphPopupData.errors_count ==
                                popupData.graphPopupData.measures_count
                                ? " text-danger"
                                : " text-warning"
                              : " text-light")
                          }
                        >
                          {popupData.graphPopupData.errors_count > 0
                            ? popupData.graphPopupData.errors_count +
                              " error on " +
                              popupData.graphPopupData.measures_count +
                              " measure"
                            : popupData.graphPopupData.measures_count > 0
                            ? popupData.graphPopupData.measures_count +
                              " measure"
                            : null}
                        </div>
                      ) : null}
                    </div>
                    {this.state._activePopup.notes.length ? (
                      <div
                        className={
                          "my-2 p-2 text-left rounded" +
                          (this.state._activePopup.notes.length == 1 &&
                          this.state._activePopup.notes[0].type == "system"
                            ? " bg-info"
                            : " bg-secondary")
                        }
                      >
                        <small>
                          {this.state._activePopup.notes.map(
                            (_C_note, _C_idx) => {
                              return (
                                <div
                                  key={_C_idx}
                                  className={
                                    "d-flex" +
                                    (_C_idx !=
                                    this.state._activePopup.notes.length - 1
                                      ? " border-bottom border-gray500"
                                      : "")
                                  }
                                >
                                  <div
                                    className="flex-grow-1"
                                    style={{ maxWidth: "270px" }}
                                  >
                                    <div
                                      className={
                                        "font-weight-normal text-wrap" +
                                        (_C_note.type == "system"
                                          ? " font-italic"
                                          : "")
                                      }
                                    >
                                      {_C_note.text}
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </small>
                      </div>
                    ) : null}
                  </div>
                }
              >
                <_LoadingWrapper loadingPlug={!popupData} showOverlay={false}>
                  <div className="p-3">
                    {popupData
                      ? (() => {
                          if (
                            popupData.graphPopupData.measures_count == 0 &&
                            popupData.graphPopupData.errors_count == 0
                          ) {
                            return (
                              <div className="sub-title text-center text-gray400">
                                No measures done.
                                <br />
                                Out of connection criteria
                                {popupData.graphPopupData.rssi != "0" ? (
                                  <div className="mt-4 pt-1 border-top border-1 border-gray600 text-gray400">
                                    <small>
                                      <Row noGutters>
                                        <div className="popup-detail-phase-color">
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "0px",
                                              width: "2px",
                                              height: "14px",
                                              border: "1px solid #de514e",
                                              borderWidth: "0 0 1px 0",
                                            }}
                                          />
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "5px",
                                              width: "3px",
                                              height: "14px",
                                              border: "1px solid #de514e",
                                              borderWidth: "1px 1px 0 1px",
                                            }}
                                          />
                                        </div>
                                        <Col className="flex-grow-1 mr-3">
                                          RSSI:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {popupData.graphPopupData.rssi}
                                          </strong>
                                        </Col>
                                        <strong className="popup-detail-phase-unit">
                                          dBm
                                        </strong>
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                      <Row noGutters>
                                        <div className="popup-detail-phase-color">
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "0px",
                                              width: "2px",
                                              height: "14px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "0 0 1px 0",
                                            }}
                                          />
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "5px",
                                              width: "3px",
                                              height: "14px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "1px 1px 0 1px",
                                            }}
                                          />
                                        </div>
                                        <Col className="flex-grow-1 mr-3">
                                          Overlap:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {popupData.graphPopupData.overlap}
                                          </strong>
                                        </Col>
                                        <div className="popup-detail-phase-unit" />
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                    </small>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (
                            !popupData.graphPopupData.measures_count &&
                            !popupData.graphPopupData.errors_count
                          ) {
                            return (
                              <div className="sub-title text-center text-gray400">
                                No measures done
                                {popupData.graphPopupData.rssi != "0" ? (
                                  <div className="mt-4 pt-1 border-top border-1 border-gray600 text-gray400">
                                    <small>
                                      <Row noGutters>
                                        <div className="popup-detail-phase-color">
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "0px",
                                              width: "2px",
                                              height: "14px",
                                              border: "1px solid #de514e",
                                              borderWidth: "0 0 1px 0",
                                            }}
                                          />
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "5px",
                                              width: "3px",
                                              height: "14px",
                                              border: "1px solid #de514e",
                                              borderWidth: "1px 1px 0 1px",
                                            }}
                                          />
                                        </div>
                                        <Col className="flex-grow-1 mr-3">
                                          RSSI:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {popupData.graphPopupData.rssi}
                                          </strong>
                                        </Col>
                                        <strong className="popup-detail-phase-unit">
                                          dBm
                                        </strong>
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                      <Row noGutters>
                                        <div className="popup-detail-phase-color">
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "0px",
                                              width: "2px",
                                              height: "14px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "0 0 1px 0",
                                            }}
                                          />
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "5px",
                                              width: "3px",
                                              height: "14px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "1px 1px 0 1px",
                                            }}
                                          />
                                        </div>
                                        <Col className="flex-grow-1 mr-3">
                                          Overlap:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {popupData.graphPopupData.overlap}
                                          </strong>
                                        </Col>
                                        <div className="popup-detail-phase-unit" />
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                    </small>
                                  </div>
                                ) : null}
                              </div>
                            );
                          } else if (
                            popupData.graphPopupData.measures_count == 0 &&
                            popupData.graphPopupData.errors_count > 0
                          ) {
                            return (
                              <div className="sub-title text-center text-gray400">
                                No measures done. <br />
                                BSSID of ESSID not visible
                              </div>
                            );
                          } else {
                            let _errors_stat =
                              (this.props.data?.graphData?.errors_statistics &&
                                this.props.data?.graphData?.errors_statistics
                                  .details[this.state._activePopup.ts + 60]) ||
                              false;
                            let _total = 0;
                            let errorMeasure;
                            return (
                              <div>
                                {popupData.graphPopupData.phases_sequence.map(
                                  (_CURR_phase, _CURR_idx) => {
                                    let className = "";
                                    _total = popupData.graphPopupData
                                      .phases_timing[_CURR_phase]
                                      ? _total +
                                        parseFloat(
                                          popupData.graphPopupData
                                            .phases_timing[_CURR_phase]
                                        )
                                      : _total;
                                    if (
                                      !errorMeasure &&
                                      _errors_stat &&
                                      _errors_stat[_CURR_phase]
                                    ) {
                                      errorMeasure =
                                        _errors_stat &&
                                        _errors_stat[_CURR_phase];
                                    }

                                    if (
                                      !errorMeasure &&
                                      !popupData.graphPopupData.phases_timing[
                                        _CURR_phase
                                      ]
                                    ) {
                                      className = "text-gray500";
                                    }
                                    return (
                                      <Row
                                        key={_CURR_idx}
                                        noGutters
                                        className={
                                          _CURR_idx <
                                          popupData.graphPopupData
                                            .phases_sequence.length -
                                            1
                                            ? "mb-1 " + className
                                            : className
                                        }
                                      >
                                        <div
                                          className={"popup-detail-phase-color"}
                                          style={{
                                            backgroundColor:
                                              _CURR_phase == this.props.step
                                                ? popupData.graphPopupData
                                                    .phases_colors[_CURR_phase]
                                                : "",
                                          }}
                                        ></div>
                                        <Col className="text-left flex-grow-1 mr-3 ml-2">
                                          {_CURR_phase}
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          {popupData.graphPopupData
                                            .phases_timing[_CURR_phase]
                                            ? popupData.graphPopupData
                                                .phases_timing[_CURR_phase] ==
                                                "1.0" ||
                                              popupData.graphPopupData
                                                .phases_timing[_CURR_phase] ==
                                                "1"
                                              ? "0"
                                              : popupData.graphPopupData
                                                  .phases_timing[_CURR_phase]
                                            : "-"}
                                        </Col>
                                        <div className="popup-detail-phase-unit">
                                          {popupData.graphPopupData
                                            .phases_timing[_CURR_phase]
                                            ? "ms"
                                            : ""}
                                        </div>
                                        <div className="popup-detail-phase-error-label">
                                          {_errors_stat &&
                                          _errors_stat[_CURR_phase] ? (
                                            <Badge color="danger">
                                              {_errors_stat[_CURR_phase]}
                                            </Badge>
                                          ) : null}
                                        </div>
                                      </Row>
                                    );
                                  }
                                )}
                                <div className="mt-2 pt-1 border-top border-2 border-primary">
                                  <Row noGutters>
                                    <Col className="flex-grow-1 mr-3 text-right">
                                      TOTAL:
                                    </Col>
                                    <Col className="mr-2 text-right">
                                      <strong>
                                        {Math.round(_total * 10) / 10}
                                      </strong>
                                    </Col>
                                    <strong className="popup-detail-phase-unit">
                                      ms
                                    </strong>
                                    <div className="popup-detail-phase-error-label" />
                                  </Row>
                                </div>
                                {this.props.data.essid != "Ethernet" ? (
                                  <div className="mt-4 pt-1 border-top border-1 border-gray600 text-gray400">
                                    <small>
                                      <Row noGutters>
                                        <div className="popup-detail-phase-color">
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "0px",
                                              width: "2px",
                                              height: "14px",
                                              border: "1px solid #de514e",
                                              borderWidth: "0 0 1px 0",
                                            }}
                                          />
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "5px",
                                              width: "3px",
                                              height: "14px",
                                              border: "1px solid #de514e",
                                              borderWidth: "1px 1px 0 1px",
                                            }}
                                          />
                                        </div>
                                        <Col className="text-left flex-grow-1 mr-3">
                                          RSSI:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {popupData.graphPopupData.rssi}
                                          </strong>
                                        </Col>
                                        <strong className="popup-detail-phase-unit">
                                          dBm
                                        </strong>
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                      <Row noGutters>
                                        <div className="popup-detail-phase-color">
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "0px",
                                              width: "2px",
                                              height: "14px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "0 0 1px 0",
                                            }}
                                          />
                                          <div
                                            style={{
                                              float: "left",
                                              marginTop: "3px",
                                              marginRight: "5px",
                                              width: "3px",
                                              height: "14px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "1px 1px 0 1px",
                                            }}
                                          />
                                        </div>
                                        <Col className="text-left flex-grow-1 mr-3">
                                          Overlap:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {popupData.graphPopupData.overlap}
                                          </strong>
                                        </Col>
                                        <div className="popup-detail-phase-unit" />
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                    </small>
                                  </div>
                                ) : null}
                              </div>
                            );
                          }
                        })()
                      : null}
                  </div>
                </_LoadingWrapper>
                <div className="text-center sub-title text-gray200 bg-gray700 rounded-bottom font-italic p-2">
                  {position == "overlay" ? (
                    <small>
                      <span className="icon-lightbulb mr-2" />
                      {this.props.popUpMessage || "Shift + Click to add notea"}
                    </small>
                  ) : (
                    <ReactOButton
                      size="sm"
                      icon="pencil"
                      onClick={() => {
                        this.props._notes_editing_ctrl.createNoteAt(
                          this.state._activePopup.ts
                        );
                      }}
                    >
                      Add note
                    </ReactOButton>
                  )}
                </div>
              </Panel>
            );
          })()
        ) : (
          <Panel
            className="graph-explorer-popup-zoom"
            rounded
            header={
              <div className="text-center text-light">
                {position == "overlay" ? (
                  "Zoom for details"
                ) : (
                  <ReactOButton
                    icon="zoom-in"
                    onClick={() => {
                      let _tick = this._explorerParameters._ticks_list.find(
                        (value) => {
                          return value == this.state._activePopup.ts;
                        }
                      );
                      let _tickIdx =
                        this._explorerParameters._ticks_list.indexOf(_tick);
                      let _isLastTick =
                        this._view_form.getEntry("is_preset") == "yes" &&
                        _tickIdx ==
                          this._explorerParameters._ticks_list.length - 1;
                      let _nextZoomViewPreset = 3600;

                      if (this._explorerParameters._range == 3600 * 24) {
                        _nextZoomViewPreset = 3600 * 4;
                      } else if (
                        this._explorerParameters._range ==
                        3600 * 24 * 7
                      ) {
                        _nextZoomViewPreset = 3600 * 24;
                      } else if (
                        this._explorerParameters._range ==
                        3600 * 24 * 7 * 4
                      ) {
                        _nextZoomViewPreset = 3600 * 24 * 7;
                      } else if (
                        this._explorerParameters._range != 3600 &&
                        this._explorerParameters._range != 3600 * 4
                      ) {
                        _nextZoomViewPreset = 3600 * 24;
                      }

                      this._view_form.handleFormChange(
                        "is_preset",
                        _isLastTick ? "yes" : "no"
                      );
                      this._view_form.handleFormChange(
                        "view_preset",
                        _isLastTick ? _nextZoomViewPreset : "no"
                      );
                      this._view_form.handleFormChange("offset", false);
                      if (!_isLastTick) {
                        this._view_form.handleFormChange(
                          "stime",
                          this.state._activePopup.ts
                        );
                        this._view_form.handleFormChange(
                          "etime",
                          this.state._activePopup.ts_end
                        );
                      }
                      this._view_form.submit();
                    }}
                  >
                    Zoom for details
                  </ReactOButton>
                )}
                {this.state._activePopup.notes.length ? (
                  <div className="my-2 p-2 text-left bg-secondary rounded">
                    <small>
                      {this.state._activePopup.notes.map((_C_note, _C_idx) => {
                        return (
                          <div
                            key={_C_idx}
                            className={
                              "d-flex" +
                              (_C_idx !=
                              this.state._activePopup.notes.length - 1
                                ? " border-bottom border-gray500"
                                : "")
                            }
                          >
                            <div
                              className="flex-grow-1"
                              style={{ maxWidth: "270px" }}
                            >
                              <div className="font-weight-normal text-wrap">
                                {_C_note.text}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </small>
                  </div>
                ) : null}
              </div>
            }
          >
            <Row noGutters>
              <Col xs={10}>
                <Row noGutters>
                  <Col xs={4} className="text-right pr-2">
                    From:
                  </Col>
                  <Col xs={8} className="text-nowrap">
                    {this.getAppContext()
                      .momentjs(this.state._activePopup.ts, "X")
                      .format("L LT")}
                  </Col>
                </Row>
                <Row noGutters>
                  <Col xs={4} className="text-right pr-2">
                    To:
                  </Col>
                  <Col xs={8} className="text-nowrap">
                    {this.getAppContext()
                      .momentjs(this.state._activePopup.ts_end, "X")
                      .format("L LT")}
                  </Col>
                </Row>
              </Col>
              <Col xs={2} className="align-self-center ">
                <span className="zoom-icon icon-zoom-in" />
              </Col>
            </Row>
          </Panel>
        )
      ) : position == "static" ? (
        <Panel className="graph-explorer-popup-zoom" rounded>
          <div className="text-center text-gray500">Tap chart for details</div>
        </Panel>
      ) : null;
    };

    return (
      <div>
        <div
          // className="mx-auto"
          style={{
            // maxWidth: this.props.data.graphData.ImgExtW + "px",
            textAlign: "initial",
          }}
        >
          <small className="text-muted ">{this.props.unit}</small>
        </div>
        <div
          id="graph-explorer-container"
          className="graph-explorer-container mx-auto"
          style={{
            maxWidth: this.props.data.graphData.ImgExtW + "px",
          }}
        >
          <div className="graph-explorer-content">
            <img
              className="graph-stepTiming"
              src={
                this.getAppContext().getApiStoreService().getCluster() +
                "/RRDgrcache/" +
                this.props.stepGraph[this.props.step].ImgName
              }
              alt="chart"
              onLoad={() => this.props.stopLoadingIMG()}
            />
          </div>
          <div className="graph-explorer-overlay-container">
            <div
              className="graph-explorer-tickers-container"
              style={{
                top: "3.36%",
                bottom: "6.71%",
                left: "5.19%",
                right: "2.5%",
              }}
              onMouseLeave={() => {
                if (!this.getAppContext().media.isMobile) {
                  this.unsetActivePopup();
                }
              }}
            >
              {(() => {
                this._explorerParameters = {
                  _range:
                    this.props.data.viewRangeData.etime -
                    this.props.data.viewRangeData.stime,
                  _ticks_list: [],
                  _notes: [],
                };

                // Mostra popup con dettagli
                if (
                  this._explorerParameters._range <= 3600 ||
                  (this._explorerParameters._range <= 3600 * 4 &&
                    !this.getAppContext().media.isMobile)
                ) {
                  this._explorerParameters._divider =
                    this.props.data.graphData.rrd_step;
                  this._explorerParameters._must_zoom = false;
                } else if (
                  this._explorerParameters._range == 3600 * 4 &&
                  this.getAppContext().media.isMobile
                ) {
                  this._explorerParameters._divider = 3600;
                  this._explorerParameters._must_zoom = true;

                  // Mostra tick di zoom
                } else if (this._explorerParameters._range == 3600 * 24) {
                  this._explorerParameters._divider = 4800;
                  this._explorerParameters.span = 3600 * 4;
                  this._explorerParameters._must_zoom = true;
                } else if (this._explorerParameters._range == 3600 * 24 * 7) {
                  this._explorerParameters._divider = 28800;
                  this._explorerParameters.span = 3600 * 24;
                  this._explorerParameters._must_zoom = true;
                } else if (
                  this._explorerParameters._range ==
                  3600 * 24 * 7 * 4
                ) {
                  this._explorerParameters._divider = 201600;
                  this._explorerParameters.span = 3600 * 24 * 7;
                  this._explorerParameters._must_zoom = true;
                } else if (
                  this._explorerParameters._range % 86400 == 0 ||
                  (this._explorerParameters._range % 86400 != 0 &&
                    this._explorerParameters._range > 86400)
                ) {
                  this._explorerParameters._divider = 28800;
                  this._explorerParameters.span = 3600 * 24;
                  this._explorerParameters._must_zoom = true;
                } else {
                  this._explorerParameters._divider = 4800;
                  this._explorerParameters.span = 3600 * 4;
                  this._explorerParameters._must_zoom = true;
                }

                this._explorerParameters._tick_width =
                  100 /
                  ((this.props.data.viewRangeData.etime -
                    this.props.data.viewRangeData.stime) /
                    this._explorerParameters._divider);
                this._explorerParameters._tickFirst_width =
                  this._explorerParameters._tick_width -
                  (this.props.data.viewRangeData.stime %
                    this.props.data.graphData.rrd_step >
                  0
                    ? 100 /
                      ((this.props.data.viewRangeData.etime -
                        this.props.data.viewRangeData.stime) /
                        (this.props.data.viewRangeData.stime %
                          this.props.data.graphData.rrd_step))
                    : 0);
                this._explorerParameters._tickLast_width =
                  this.props.data.viewRangeData.stime %
                    this.props.data.graphData.rrd_step >
                  0
                    ? 100 /
                      ((this.props.data.viewRangeData.etime -
                        this.props.data.viewRangeData.stime) /
                        (this.props.data.viewRangeData.stime %
                          this.props.data.graphData.rrd_step))
                    : 0;
                for (
                  let n =
                    !this._explorerParameters._must_zoom &&
                    this.props.data.graphData.rrd_step > 60
                      ? this.props.data.viewRangeData.stime -
                        (this.props.data.viewRangeData.stime %
                          this.props.data.graphData.rrd_step)
                      : this.props.data.viewRangeData.stime;
                  !this._explorerParameters._must_zoom &&
                  this.props.data.graphData.rrd_step > 60
                    ? n <= this.props.data.viewRangeData.etime
                    : n < this.props.data.viewRangeData.etime;
                  n += this._explorerParameters._divider
                ) {
                  this._explorerParameters._ticks_list.push(n);
                }

                this._explorerParameters._notes = (
                  this.props.notes || []
                ).filter((value) => {
                  return (
                    value.ts >= this.props.data.viewRangeData.stime &&
                    value.ts < this.props.data.viewRangeData.etime
                  );
                });
                return this._explorerParameters._ticks_list.map(
                  (_CURR_tick, _CURR_idx, array) => {
                    let _TMP_tick_notes =
                      this._explorerParameters._notes.filter((value) => {
                        return (
                          value.ts >= _CURR_tick &&
                          value.ts <
                            _CURR_tick + this._explorerParameters._divider
                        );
                      });
                    let _TMP_left = 0;
                    let _TMP_width = 0;
                    if (this._explorerParameters._must_zoom) {
                      // IF LAST IDX, set last width for personal timing
                      // console.log("_tick_width standard", _tick_width);
                      _TMP_left =
                        this._explorerParameters._tick_width * _CURR_idx;
                      if (_CURR_idx == array.length - 1) {
                        _TMP_width = 100 - _TMP_left;
                      } else {
                        _TMP_width = this._explorerParameters._tick_width;
                      }
                    } else {
                      _TMP_left =
                        this._explorerParameters._tick_width * _CURR_idx -
                        (this.props.data.graphData.rrd_step > 60 &&
                        _CURR_idx > 0
                          ? this._explorerParameters._tickLast_width
                          : 0);
                      _TMP_width =
                        this.props.data.graphData.rrd_step > 60
                          ? _CURR_idx == 0
                            ? this._explorerParameters._tickFirst_width
                            : _CURR_idx ==
                              this._explorerParameters._ticks_list.length - 1
                            ? this._explorerParameters._tickLast_width
                            : this._explorerParameters._tick_width
                          : this._explorerParameters._tick_width;
                    }

                    let _overZoomTick = () => {
                      let twin = [];
                      let ts;
                      let ts_end;
                      let span = this._explorerParameters.span; // this._explorerParameters._divider;
                      // let tick_x;
                      if (_CURR_idx == 0) {
                        twin.push(array[_CURR_idx + 1], array[_CURR_idx + 2]);
                        ts = _CURR_tick;
                        ts_end = _CURR_tick + span;
                        // tick_x = this._explorerParameters._tick_width * (_CURR_idx + 2);
                      } else if (_CURR_idx == 1) {
                        twin.push(array[_CURR_idx - 1], array[_CURR_idx + 1]);
                        ts = array[_CURR_idx - 1];
                        ts_end = array[_CURR_idx - 1] + span;
                        // tick_x = this._explorerParameters._tick_width * _CURR_idx + 6;
                      } else if (_CURR_idx == array.length - 1) {
                        twin.push(array[_CURR_idx - 1], array[_CURR_idx - 2]);
                        ts = array[_CURR_idx - 2];
                        ts_end = array[_CURR_idx - 2] + span;
                        // tick_x = this._explorerParameters._tick_width * (_CURR_idx - 1);
                      } else if (_CURR_idx == array.length - 2) {
                        twin.push(array[_CURR_idx - 1], array[_CURR_idx + 1]);
                        ts = array[_CURR_idx - 1];
                        ts_end = array[_CURR_idx - 1] + span;
                        // tick_x = this._explorerParameters._tick_width * (_CURR_idx - 2);
                      } else {
                        twin.push(array[_CURR_idx - 1], array[_CURR_idx + 1]);
                        ts = array[_CURR_idx - 1];
                        ts_end = array[_CURR_idx - 1] + span;
                        // tick_x = this._explorerParameters._tick_width * (_CURR_idx - 1);
                      }
                      this.setActivePopup({
                        hovered: _CURR_tick,
                        ts: ts,
                        twin: twin,
                        ts_end:
                          this.state.customRange &&
                          _CURR_idx == array.length - 1
                            ? this.getAppContext()
                                .getLocalStorageService()
                                .get("measure_graph_view").etime
                            : ts_end,
                        tick_x:
                          this._explorerParameters._tick_width * _CURR_idx,
                        tick_width: this._explorerParameters._tick_width,
                        _is_zoom: true,
                      });
                    };

                    let _clickZoomTick = () => {
                      this.getAppContext()
                        .getLocalStorageService()
                        .set("measure_steplist_view.is_preset", "no");
                      this.getAppContext()
                        .getLocalStorageService()
                        .set("measure_steplist_view.view_preset", "no");
                      this.getAppContext()
                        .getLocalStorageService()
                        .set("measure_steplist_view.offset", false);
                      this.getAppContext()
                        .getLocalStorageService()
                        .set(
                          "measure_steplist_view.stime",
                          this.state._activePopup.ts
                        );
                      this.getAppContext()
                        .getLocalStorageService()
                        .set(
                          "measure_steplist_view.etime",
                          this.state._activePopup.ts_end
                        );
                      this.props.loadStepBatch();
                    };

                    let _overDataTick = () => {
                      this.setActivePopup({
                        ts: _CURR_tick,
                        ts_end: _CURR_tick + this._explorerParameters._divider,
                        retention_ts_range:
                          this.props.data.graphData.rrd_step > 60
                            ? {
                                ts:
                                  _CURR_tick -
                                  this.props.data.graphData.rrd_step / 2,
                                ts_end:
                                  _CURR_tick -
                                  this.props.data.graphData.rrd_step / 2 +
                                  this._explorerParameters._divider,
                              }
                            : undefined,
                        tick_x:
                          this._explorerParameters._tick_width * _CURR_idx -
                          (this.props.data.graphData.rrd_step > 60 &&
                          _CURR_idx > 0
                            ? this._explorerParameters._tickLast_width
                            : 0),
                        tick_width:
                          this.props.data.graphData.rrd_step > 60
                            ? _CURR_idx == 0
                              ? this._explorerParameters._tickFirst_width
                              : _CURR_idx ==
                                this._explorerParameters._ticks_list.length - 1
                              ? this._explorerParameters._tickLast_width
                              : this._explorerParameters._tick_width
                            : this._explorerParameters._tick_width,
                        _is_zoom: false,
                      });
                    };

                    let _clickDataTick = (e) => {
                      if (e.shiftKey) {
                        this.props._notes_editing_ctrl.createNoteAt(_CURR_tick);
                      } else if (e.metaKey) {
                        window.open(
                          "/web/" +
                            this.props.match.params.probeuid +
                            "/" +
                            this.props.match.params.status +
                            "/" +
                            this.props.match.params.measureid +
                            "/" +
                            this.props.match.params.bssid +
                            "/results/" +
                            _CURR_tick +
                            "/i",
                          "_blank"
                        );
                      } else {
                        this.getAppContext().redirectTo({
                          pathname:
                            "/" +
                            this.props.match.params.probeuid +
                            "/" +
                            this.props.match.params.status +
                            "/" +
                            this.props.match.params.measureid +
                            "/" +
                            this.props.match.params.bssid +
                            "/results/" +
                            _CURR_tick +
                            "/i",
                          // state: this.props.stepGraph,
                        });
                      }
                    };

                    return this._explorerParameters._must_zoom ? (
                      <div
                        key={_CURR_idx + ".1_"}
                        // className={
                        //   "graph-explorer-tick zoom-tick" +
                        //   (this.state._activePopup &&
                        //   this.state._activePopup.ts == _CURR_tick
                        //     ? " active"
                        //     : "")
                        // }
                        className={
                          "graph-explorer-tick zoom-tick" +
                          (this.state._activePopup &&
                          (this.state._activePopup.hovered == _CURR_tick ||
                            this.state._activePopup.twin.includes(_CURR_tick))
                            ? " active"
                            : "")
                        }
                        style={{
                          cursor: "pointer",
                          left: _TMP_left + "%",
                          width: _TMP_width + "%",
                        }}
                        onMouseOver={() => {
                          _overZoomTick();
                        }}
                        onClick={() => {
                          if (this.props.disableClick) {
                            console.log("disabled");
                          } else {
                            if (this.getAppContext().media.isMobile) {
                              _overZoomTick();
                            } else {
                              _clickZoomTick();
                            }
                          }
                        }}
                      ></div>
                    ) : (
                      <div
                        key={_CURR_idx + ".2_"}
                        //href={'/' + this.props.match.params.probeuid + '/' + this.props.match.params.status + '/' + this.props.match.params.measureid + '/' + this.props.match.params.bssid + '/results/' + (_CURR_tick) + '/i'}
                        className={
                          "graph-explorer-tick" +
                          (this.state._activePopup &&
                          this.state._activePopup.ts == _CURR_tick
                            ? " active"
                            : "") +
                          (_TMP_tick_notes.length ? " bg-gray500" : "")
                        }
                        style={{
                          left:
                            this._explorerParameters._tick_width * _CURR_idx -
                            (this.props.data.graphData.rrd_step > 60 &&
                            _CURR_idx > 0
                              ? this._explorerParameters._tickLast_width
                              : 0) +
                            "%",
                          width:
                            array.length == 1
                              ? "100%"
                              : (this.props.data.graphData.rrd_step > 60
                                  ? _CURR_idx == 0
                                    ? this._explorerParameters._tickFirst_width
                                    : _CURR_idx ==
                                      this._explorerParameters._ticks_list
                                        .length -
                                        1
                                    ? this._explorerParameters._tickLast_width
                                    : this._explorerParameters._tick_width
                                  : this._explorerParameters._tick_width) + "%",
                        }}
                        onMouseOver={() => {
                          _overDataTick();
                        }}
                        onClick={(e) => {
                          if (this.props.disableClick) {
                            console.log("disabled");
                          } else {
                            if (this.getAppContext().media.isMobile) {
                              _overDataTick();
                            } else {
                              _clickDataTick(e);
                            }
                          }
                        }}
                      ></div>
                    );
                  }
                );
              })()}
              {!this.getAppContext().media.isMobile &&
              this.state._activePopup ? (
                <div
                  className={
                    "graph-explorer-overlay-popup" +
                    (this.state._activePopup.tick_x >= 50 ? " mr-2" : " ml-2")
                  }
                  style={{
                    top: this.props.idx <= 3 ? "20%" : 0, // fix top position for popup,
                    ...(this.state._activePopup.tick_x >= 50
                      ? {
                          right: 100 - this.state._activePopup.tick_x + "%",
                        }
                      : {
                          left:
                            this.state._activePopup.tick_x +
                            this.state._activePopup.tick_width +
                            "%",
                        }),
                  }}
                >
                  {_popup("overlay")}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default contextProvider(withRouter(StepTimingGraph), {
  define: null,
});
